// Package imports:
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
// Style imports:
import './DuplicateMassReviewModal.scss'
// Component imports:
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import AlertOverview from './AlertOverview';
// Type imports:
import { AlertTickData, AlertStatus } from '../../types/api/AlertTypes';
import AlertInfo from './singlereviewparts/AlertInfo';

type Tabs = 'New Review' | 'Alert Overview';

interface DuplicateMassReviewModalProps {
    show: boolean;
    duplicates: AlertTickData[];
    defaultStatus: AlertStatus;
    defaultComment: string;
    onStatusChange: (status: AlertStatus) => void;
    onCommentChange: (comment: string) => void;
    onAccept: () => void;
    onDecline: () => void;
}

const TABS: Tabs[] = ['New Review', 'Alert Overview'];
const alertStatuses: Array<{ name: string, value: AlertStatus }> = [
    { name: 'Open', value: 'open' },
    { name: 'Watch', value: 'watch' },
    { name: 'Investigating', value: 'investig' },
    { name: 'Critical', value: 'critical' },
    { name: 'Explained', value: 'explained' },
    { name: 'Closed', value: 'closed' },
];

const DuplicateMassReviewModal: React.FC<DuplicateMassReviewModalProps> = ({
    show,
    duplicates,
    defaultStatus,
    defaultComment,
    onStatusChange,
    onCommentChange,
    onAccept,
    onDecline
}) => {
    const [selectedTab, setSelectedTab] = React.useState<Tabs>('New Review');

    return (
        <Modal show={show} onHide={onDecline} centered size="lg" backdrop="static" dialogClassName="DuplicateMassReviewModal">
            <Modal.Header>
                <Modal.Title>Mass Review Duplicates</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='PanelTabSelector'>
                    <div className='BackgroundBar' />
                    <div className='PanelTabs'>
                        {TABS.map((tabTitle, index) => (
                            <div
                                key={index}
                                onClick={() => setSelectedTab(tabTitle)}
                                className={'PanelTab' + ((selectedTab === tabTitle) ? ' SelectedTab' : '')}
                            >
                                {(selectedTab === tabTitle) ? <div className='SelectedTabBackground' /> : null}
                                {tabTitle}
                            </div>
                        ))}
                    </div>
                </div>
                {selectedTab === 'New Review' ? (
                    <>
                        <div className="InfoBox">
                            <span>
                                You are about to mass review <b>{duplicates.length}</b> duplicate alerts.
                                News title triggering this duplicate mass review: <b>{duplicates[0]?.newstitle}</b> for symbol <b>{duplicates[0]?.symbol}</b>.
                            </span>
                        </div>
                        <div className='AlertStatusRadioList'>
                            {alertStatuses.map(({ name, value }) => (
                                <div
                                    key={value}
                                    className='AlertStatusRadioWrapper'
                                    onClick={() => onStatusChange(value)}
                                >
                                    <div
                                        className={`AlertStatusRadioButton ${value} ${(value === defaultStatus) ? 'Selected' : ''}`}
                                    >
                                        {(value === defaultStatus) ? (
                                            <FontAwesomeIcon icon={faCheck} className='CheckmarkIcon' />
                                        ) : null}
                                    </div>
                                    <span className='AlertStatusRadioLabel'>{name}</span>
                                </div>
                            ))}
                            <Form.Control
                                as='textarea'
                                className='AlertStatusTextArea'
                                rows={3}
                                placeholder='Type comment'
                                value={defaultComment}
                                onChange={e => onCommentChange(e.target.value)}
                            />
                        </div>
                    </>
                ) : (
                    <AlertOverview alerts={duplicates} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onDecline}>No, review only this alert</Button>
                <Button variant="primary" onClick={onAccept}>Yes, mass review all</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DuplicateMassReviewModal;
